import { en, ru, fr, es, de, ja } from "vuetify/locale";
import enL from "~/locales/en.json";
import ruL from "~/locales/ru.json";
import frL from "~/locales/fr.json";
import esL from "~/locales/es.json";
import deL from "~/locales/de.json";
import jaL from "~/locales/ja.json";
const messages = {
	en: {
		...enL,
		$vuetify: { ...en }
	},
	ru: {
		...ruL,
		$vuetify: { ...ru }
	},
	fr: {
		...frL,
		$vuetify: { ...fr }
	},
	es: {
		...esL,
		$vuetify: { ...es }
	},
	de: {
		...deL,
		$vuetify: { ...de }
	},
	ja: {
		...jaL,
		$vuetify: { ...ja }
	}
};
export default () => ({
	strategy: "prefix",
	legacy: false,
	locale: "en",
	fallbackWarn: false,
	missingWarn: false,
	fallbackLocale: "en",
	messages
});
